// ── At a Glance slider ────────────────────────────────────────────────────────
jQuery(function ($) {
    $('.glance-slider').each(function () {
        var $wrap = $(this).closest('.glance-slider-wrap');
        var count = parseInt($wrap.data('cards')) || 1;
        var single = count <= 1;

        $(this).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: !single,
            prevArrow: '<button type="button" class="glance-prev-slick"></button>',
            nextArrow: '<button type="button" class="glance-next-slick"></button>',
            dots: false,
            adaptiveHeight: true,
            infinite: !single,
        });

        // Wire the in-card arrow buttons to Slick
        if (!single) {
            var $slider = $(this);
            $wrap.on('click', '.glance-prev', function () { $slider.slick('slickPrev'); });
            $wrap.on('click', '.glance-next', function () { $slider.slick('slickNext'); });
        }
    });
});

// ── Consent Forms search ──────────────────────────────────────────────────────
jQuery(function ($) {
    var $input = $('#consent-search');
    if (!$input.length) return;

    $input.on('input', function () {
        var query = $(this).val().trim().toLowerCase();

        $('.consent-category').each(function () {
            var $cat = $(this);
            var anyVisible = false;

            $cat.find('.consent-item').each(function () {
                var name = ($(this).data('name') || '').toLowerCase();
                var match = !query || name.includes(query);
                $(this).toggle(match);
                if (match) anyVisible = true;
            });

            $cat.toggle(anyVisible);
        });
    });
});

jQuery("#back-top").hide();
jQuery(function () {
    jQuery(window).scroll(function () {
        if (jQuery(this).scrollTop() > 1000) {
            jQuery('#back-top').fadeIn();
            jQuery("#back-top").addClass('active');
        } else {
            jQuery('#back-top').fadeOut();
            jQuery("#back-top").removeClass('active');
        }
    });
    jQuery('#back-top').click(function () {
        jQuery('body,html').animate({
            scrollTop: 0
        }, 1000);
        return false;
    });
});


/********************** Mobile menu ********************** */
jQuery(document).on("click", ".navbar-toggler,.close-menu", function (e) {
    jQuery(jQuery(this).attr('data-target')).toggleClass("show");
});


$(document).ready(function () {

    // Blog post: copy link to clipboard
    $(document).on('click', '.blog-copy-link', function () {
        var url = $(this).data('copy-url');
        var $label = $(this).find('span');
        navigator.clipboard.writeText(url).then(function () {
            $label.text('Copied!');
            setTimeout(function () { $label.text('Copy Link'); }, 2000);
        });
    });

    $('#toggleMenu').on('click', function () {
        $('.primary-menu-wrapper').toggleClass('openmenu');
        $('.header-navigation').toggleClass('open-menu');
    });

    // Footer conditions sub-menu — accordion with smooth slide
    $('.footer-conditions-nav .menu-item-has-children > a').on('click', function (e) {
        var $item = $(this).closest('.menu-item-has-children');
        var $sub = $item.find('> .sub-menu');
        if (!$sub.length) return;
        e.preventDefault();
        var isOpen = $item.hasClass('footer-sub-open');

        // Slide up + close all siblings
        $item.siblings('.menu-item-has-children.footer-sub-open')
            .removeClass('footer-sub-open')
            .find('> .sub-menu').slideUp(250);

        // Toggle clicked item
        if (isOpen) {
            $item.removeClass('footer-sub-open');
            $sub.slideUp(250);
        } else {
            $item.addClass('footer-sub-open');
            $sub.slideDown(250);
        }
    });

    $('.menuCloseIcon').on('click', function () {
        $('.primary-menu-wrapper').removeClass('openmenu');
        $('.header-navigation').removeClass('open-menu');
    });



    // Slick carousels use lazyLoad:'ondemand' with data-lazy on <img>.
    // When Slick sets img.src the browser re-evaluates the parent <picture>
    // and automatically serves AVIF or WebP via the <source> elements.
    $('.home-about-carousel').slick({
        slidesToShow: 4,
        centerMode: true,
        centerPadding: '305px',
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        cssEase: 'linear',
        infinite: true,
        variableWidth: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        lazyLoad: 'ondemand',
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    centerPadding: '160px',
                },
            },
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '20px',
                    slidesToShow: 1,
                    variableWidth: false,
                },
            },

        ],
    });

    var $vcSlider = $('.video-carousel-slider');
    $vcSlider.slick({
        slidesToShow: 3,
        centerMode: true,
        centerPadding: '285px',
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 700,
        cssEase: 'ease',
        infinite: true,
        dots: false,
        lazyLoad: 'ondemand',
        variableWidth: true,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    centerPadding: '160px',
                },
            },
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '60px',
                    slidesToShow: 1,
                    variableWidth: false,
                },
            },

        ],
    });

    // Video carousel prev/next arrows
    $(document).on('click', '.vc-prev', function () { $vcSlider.slick('slickPrev'); });
    $(document).on('click', '.vc-next', function () { $vcSlider.slick('slickNext'); });

    // FAQ accordion — one open at a time; first item open by default
    $(document).on('click', '.faq-toggle', function () {
        var $btn = $(this);
        var $item = $btn.closest('.faq-item');
        var $list = $item.closest('.flex-col');
        var isOpen = $btn.attr('aria-expanded') === 'true';

        // Close all siblings
        $list.find('.faq-item').not($item).each(function () {
            $(this).removeClass('faq-open')
                .find('.faq-toggle').attr('aria-expanded', 'false');
            $(this).find('.faq-answer').slideUp(300);
        });

        // Toggle clicked item
        $btn.attr('aria-expanded', String(!isOpen));
        $item.toggleClass('faq-open', !isOpen);
        $btn.next('.faq-answer')[isOpen ? 'slideUp' : 'slideDown'](300);
    });

    // Treatments accordion — whole item clickable, smooth slide
    $(document).on('click', '.treatment-item', function () {
        var $item = $(this);
        var id = $item.data('treatment-id');
        var $button = $item.find('.toggle-button');
        var isExpanded = $button.attr('aria-expanded') === 'true';

        $('.treatment-content').slideUp(300);
        $('.toggle-button').attr('aria-expanded', 'false').find('span').text('+');
        $('.treatment-item').removeClass('treatment-open');

        if (!isExpanded) {
            $('.treatment-content[data-treatment-id="' + id + '"]').slideDown(300);
            $button.attr('aria-expanded', 'true').find('span').html('&#8722;');
            $item.addClass('treatment-open');
            var imageUrl = $item.data('image-url');
            var videoUrl = $item.data('video-url');

            if (videoUrl) {
                // Show video, hide image
                $('#home-treatment-video').attr('src', videoUrl).removeClass('hidden')[0].load();
                $('#home-treatment-image').addClass('hidden');
                $('#mobile-treatment-video').attr('src', videoUrl).removeClass('hidden')[0].load();
                $('#mobile-treatment-image').addClass('hidden');
            } else if (imageUrl) {
                // Show image, hide video
                $('#home-treatment-image').attr('src', imageUrl).removeClass('hidden');
                $('#home-treatment-video').attr('src', '').addClass('hidden');
                $('#mobile-treatment-image').attr('src', imageUrl).removeClass('hidden');
                $('#mobile-treatment-video').attr('src', '').addClass('hidden');
            }
        }
    });

    // Philosophy image carousel — skewed variable-width cards
    $('.image-carousel').slick({
        slidesToShow: 3,
        centerMode: true,
        centerPadding: '285px',
        variableWidth: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 3000,
        speed: 700,
        cssEase: 'linear',
        infinite: true,
        lazyLoad: 'ondemand',
        pauseOnHover: false,
        pauseOnFocus: false,
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    centerPadding: '160px',
                },
            },
            {
                breakpoint: 768,
                settings: {
                    centerPadding: '40px',
                    slidesToShow: 1,
                    variableWidth: false,
                },
            },

        ],
    });

    // Testimonials carousel — Slick
    $('.testimonials-slider').slick({
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 6000,
        speed: 400,
        arrows: false,
        dots: true,
        infinite: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        lazyLoad: 'ondemand',
        appendDots: $('.testimonials-dots'),
        adaptiveHeight: true,
        customPaging: function () {
            return '<button></button>';
        },
    });


    // Results / social-proof auto-scroll carousels
    $('.ts-results-slider, .ts-cc-slider, .ts-csp-slider').each(function () {
        $(this).slick({
            slidesToShow: 5,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 0,
            speed: 4000,
            cssEase: 'linear',
            arrows: false,
            dots: false,
            infinite: true,
            pauseOnHover: false,
            pauseOnFocus: false,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 3 } },
                { breakpoint: 640, settings: { slidesToShow: 2 } },
            ],
        });
    });

    // ─── Gallery — filter + pagination via show/hide (no HTML generation) ───────
    if ($('#gallery-grid').length) {
        var GALLERY_PER_PAGE = parseInt($('#gallery-grid').data('per-page')) || 5;
        var galleryState = { tag: 'all', page: 0 };

        function galleryUpdate() {
            var $all = $('#gallery-grid .gallery-item');

            // Items matching current filter
            var $visible = $all.filter(function () {
                return galleryState.tag === 'all' || $(this).data('tag') === galleryState.tag;
            });

            var totalPages = Math.max(1, Math.ceil($visible.length / GALLERY_PER_PAGE));
            galleryState.page = Math.max(0, Math.min(galleryState.page, totalPages - 1));

            var pageStart = galleryState.page * GALLERY_PER_PAGE;
            var $page = $visible.slice(pageStart, pageStart + GALLERY_PER_PAGE);

            // Reset all: hide + remove layout role
            $all.addClass('gallery-hidden').removeClass('gallery-large');

            // Show current page items + assign layout roles
            $page.each(function (i) {
                $(this).removeClass('gallery-hidden');
                if (i === 0) $(this).addClass('gallery-large');
            });

            // Pagination button states
            var atStart = galleryState.page === 0;
            var atEnd = galleryState.page >= totalPages - 1;
            $('#gallery-prev').prop('disabled', atStart).toggleClass('opacity-30 cursor-default', atStart);
            $('#gallery-next').prop('disabled', atEnd).toggleClass('opacity-30 cursor-default', atEnd);
        }

        // Filter click
        $(document).on('click', '.gallery-filter-btn', function () {
            galleryState.tag = $(this).data('tag');
            galleryState.page = 0;
            $('.gallery-filter-btn')
                .removeClass('gallery-filter-active bg-light text-white')
                .addClass('text-secondary bg-muted');
            $(this).addClass('gallery-filter-active bg-light text-white')
                .removeClass('text-secondary bg-muted');
            galleryUpdate();
        });

        // Prev / Next
        $('#gallery-prev').on('click', function () {
            if (galleryState.page > 0) { galleryState.page--; galleryUpdate(); }
        });
        $('#gallery-next').on('click', function () {
            galleryState.page++;
            galleryUpdate();
        });

        galleryUpdate();
    }

    // ─── Treatment Service — correction feature cards slider ─────────────────
    $('.correction-cards-section').each(function () {
        var $section = $(this);
        var $slider = $section.find('.correction-cards-slider');

        $slider.slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            infinite: true,
            dots: false,
            variableWidth: true,
            responsive: [
                { breakpoint: 1024, settings: { slidesToShow: 2 } },
                { breakpoint: 640, settings: { slidesToShow: 1 } },
            ],
        });

        $section.find('.correction-card-prev').on('click', function () {
            $slider.slick('slickPrev');
        });
        $section.find('.correction-card-next').on('click', function () {
            $slider.slick('slickNext');
        });
    });

    // ─── SDL Difference — page-specific feature slider (5+ items) ───────────
    $('.sdl-diff-slider').each(function () {
        var $slider = $(this);
        var id = $slider.data('slider-id');

        $slider.slick({
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: false,
            infinite: true,
            dots: false,
            responsive: [
                { breakpoint: 1280, settings: { slidesToShow: 3 } },
                { breakpoint: 768, settings: { slidesToShow: 2 } },
                { breakpoint: 480, settings: { slidesToShow: 1 } },
            ],
        });

        $('[data-target="' + id + '"].sdl-diff-prev').on('click', function () {
            $slider.slick('slickPrev');
        });
        $('[data-target="' + id + '"].sdl-diff-next').on('click', function () {
            $slider.slick('slickNext');
        });
    });

    // ─── Clinics page — feature cards Slick slider ───────────────────────────
    $('.clinic-feature-slider').each(function () {
        var $slider = $(this);
        var $panel = $slider.closest('.clinic-location-panel');

        $slider.slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: false,
            infinite: true,
            dots: false,
            infinite: true,
            responsive: [{
                breakpoint: 640,
                settings: { slidesToShow: 1 },
            }],
        });

        $panel.find('.clinic-feature-prev').on('click', function () {
            $slider.slick('slickPrev');
        });
        $panel.find('.clinic-feature-next').on('click', function () {
            $slider.slick('slickNext');
        });
    });

    // ─── Clinics page — location tab switcher ────────────────────────────────
    $(document).on('click', '.clinic-tab-btn', function () {
        var idx = $(this).data('index');
        $('.clinic-tab-btn')
            .removeClass('clinic-tab-active bg-light text-white')
            .addClass('text-secondary bg-muted');
        $(this)
            .addClass('clinic-tab-active bg-light text-white')
            .removeClass('text-secondary bg-muted');
        $('.clinic-location-panel').addClass('hidden');
        var $panel = $('.clinic-location-panel[data-index="' + idx + '"]').removeClass('hidden');
        // Slick needs a recalc after a hidden panel becomes visible
        $panel.find('.clinic-feature-slider').slick('setPosition');
    });

    // ─── Treatment Cards — horizontal slider with category filter ────────────
    $('.cl-treatments-slider').each(function () {
        var $slider = $(this);
        var id = $slider.data('slider-id');

        $slider.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            infinite: true,
            dots: false,
            responsive: [
                { breakpoint: 1280, settings: { slidesToShow: 2 } },
                { breakpoint: 768, settings: { slidesToShow: 1 } },
            ],
        });

        $('[data-target="' + id + '"].cl-treatments-prev').on('click', function () {
            $slider.slick('slickPrev');
        });
        $('[data-target="' + id + '"].cl-treatments-next').on('click', function () {
            $slider.slick('slickNext');
        });
    });

    // Treatment Cards filter dropdown toggle
    $(document).on('click', '.cl-treatments-filter-btn', function (e) {
        e.stopPropagation();
        var $dropdown = $(this).siblings('.cl-treatments-filter-dropdown');
        $dropdown.toggleClass('hidden');
    });

    // Treatment Cards filter option select
    $(document).on('click', '.cl-treatments-filter-option', function () {
        var $option = $(this);
        var $filter = $option.closest('.cl-treatments-filter');
        var tag = $option.data('tag');
        var id = $filter.data('target');

        $filter.find('.cl-treatments-filter-label').text($option.text().trim());
        $filter.find('.cl-treatments-filter-dropdown').addClass('hidden');
        $filter.find('.cl-treatments-filter-option').removeClass('cl-treatments-filter-active');
        $option.addClass('cl-treatments-filter-active');

        var $slider = $('.cl-treatments-slider[data-slider-id="' + id + '"]');
        $slider.slick('slickUnfilter');
        if (tag !== 'all') {
            $slider.slick('slickFilter', '[data-card-tag="' + tag + '"]');
        }
    });

    // Close treatment filter dropdown when clicking outside
    $(document).on('click', function (e) {
        if (!$(e.target).closest('.cl-treatments-filter').length) {
            $('.cl-treatments-filter-dropdown').addClass('hidden');
        }
    });

    if (window.innerWidth < 992) {
        $('.mobile-slider').each(function () {
            var $slider = $(this);
            var $wrap = $slider.closest('.cat-slider-wrap');

            $slider.slick({
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: false,
                dots: false,
                infinite: false,
                adaptiveHeight: true,
                speed: 400,
            });

            // Wire prev/next buttons via event delegation — avoids Slick moving them
            if ($wrap.length) {
                $wrap.on('click', '.cat-prev', function () { $slider.slick('slickPrev'); });
                $wrap.on('click', '.cat-next', function () { $slider.slick('slickNext'); });
            }
        });
    }

    // LazyLoad is initialised LAST — after all Slick carousels — so it sees
    // the complete DOM including cloned slides. It handles:
    //   • background images:  .lazy[data-bg]  (e.g. about/banner section)
    //   • carousel videos:    video.lazy with <source data-src>
    new LazyLoad({
        elements_selector: '.lazy',
        callback_loaded: function (el) {
            // autoplay attribute alone won't re-fire after a JS-driven video.load();
            // explicitly call play() to start the video once its sources are ready.
            if (el.tagName === 'VIDEO') {
                el.play().catch(function () { });
            }
        },
    });


});
